
export enum AccountStatus {
    Active = 1,
    WaitingConfirmation = 2,
    RegistrationDeclined = 3,
    Blocked = 4,
    New = 5,
    WaitingCertificateConfirmation = 6,
    AccessDenied = 7,
    InvalidCertificate = 8,
    NotAccepted = 9,
    WaitingConfirmPersonalData = 10,
    PersonalDataComfirmed = 11
}

export var AccountStatusDescription: { [key: AccountStatus]: string; } = {};
AccountStatusDescription[AccountStatus.Active] = "Активен";
AccountStatusDescription[AccountStatus.WaitingConfirmation] = "Ожидает подтверждения";
AccountStatusDescription[AccountStatus.Blocked] = "Заблокирован";
AccountStatusDescription[AccountStatus.New] = "Новый";
AccountStatusDescription[AccountStatus.WaitingCertificateConfirmation] = "Ожидает подтверждения сертификата";
AccountStatusDescription[AccountStatus.AccessDenied] = "Вход в систему запрещен";
AccountStatusDescription[AccountStatus.InvalidCertificate] = "Некорректный сертификат";
AccountStatusDescription[AccountStatus.NotAccepted] = "Не принято";
AccountStatusDescription[AccountStatus.RegistrationDeclined] = 'В регистрации отказано';
AccountStatusDescription[AccountStatus.WaitingConfirmPersonalData] = 'Ожидание подтверждения персональных данных';
AccountStatusDescription[AccountStatus.PersonalDataComfirmed] = 'Персональные данные подтверждены';

export enum CheckingStatuses {
    NoStatus = 0,
    ReadyToCheck = 1,
    Adopted = 2,
    CheckFailed = 3,
    Draft = 4
}

export var CheckingStatusesDescription: { [key: CheckingStatuses]: string; } = {};
CheckingStatusesDescription[CheckingStatuses.NoStatus] = "Нет статуса";
CheckingStatusesDescription[CheckingStatuses.ReadyToCheck] = 'Подготовлен к проверке';
CheckingStatusesDescription[CheckingStatuses.Adopted] = 'Принят';
CheckingStatusesDescription[CheckingStatuses.CheckFailed] = 'Не прошел проверку';
CheckingStatusesDescription[CheckingStatuses.Draft] = 'Черновик';

export enum CompanyTypes {
    OOO = 1,
    IP = 2,
    Fiz = 3
}

export var CompanyTypesName: { [key: CompanyTypes]: string; } = {};
CompanyTypesName[CompanyTypes.OOO] = 'Юридическое лицо';
CompanyTypesName[CompanyTypes.IP] = 'Индивидуальный предприниматель';
CompanyTypesName[CompanyTypes.Fiz] = 'Физическое лицо';

